


















































import { Component, Vue } from "vue-property-decorator"
import { mapState } from "vuex"
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from "@/constants/booking_candidate"
import { TYPES } from "@/constants/booking"

@Component({
  computed: {
    ...mapState("Auth", {
      candidate: "candidate",
      user: "user"
    }),
    ...mapState("BookingCandidate", {
      bookingCandidate: "bookingCandidate"
    }),
  }
})
export default class BookingCandidateReadQuestionnaireProgress extends Vue {
  // candidate State
  candidate!: Model
  user!: Model
  // bookingCandidate State
  bookingCandidate!: BookingCandidate
  types = TYPES
  bookingCandidateStatuses = BOOKING_CANDIDATE_STATUSES

  isLoading = false

  get canStart() {
    if (this.bookingCandidate.status && [
      this.bookingCandidateStatuses.STATUS_AWAIT_START.key,
      this.bookingCandidateStatuses.STATUS_CANDIDATE_INPUTTING.key,
    ].includes(this.bookingCandidate.status)) {
      return true
    }
    return false
  }

  get booking() {
    return this.bookingCandidate.booking
  }

  get questionnaire() {
    return this.booking.questionnaire
  }

  get questionnaireAnswer() {
    return this.bookingCandidate.questionnaire_answer || null
  }

  get questionnaireAnswerProgress() {
    if (!this.questionnaireAnswer) {
      return 0
    }
    return ~~(this.questionnaireAnswer.progress * 100) || 0
  }

  async toAnswer(isStartOver) {
    this.isLoading = true
    if (isStartOver && this.questionnaireAnswer) {
      await this.$store.dispatch('QuestionnaireAnswer/startOver', this.questionnaireAnswer.object_id)
    }
    this.$store.dispatch("BookingCandidate/startQuestionnaire", this.$route.params.bookingCandidateOid).then(() => {
      this.$store.dispatch("BookingCandidate/fetch", this.$route.params.bookingCandidateOid).then(() => {
        this.$router.push({
          name: "candidate-start-selected-questionnaire",
          params: {
            beOid: this.$route.params.bookingCandidateOid,
          },
        })
        this.isLoading = false
      })
    })
  }
}
